/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { FinancialSeries } from "./FinancialSeries";
import { DependencyProperty } from "igniteui-react-core";
import { ISortingAxis_$type } from "./ISortingAxis";
import { typeCast, markType, markDep } from "igniteui-react-core";
import { Rect } from "igniteui-react-core";
import { ScalerParams } from "./ScalerParams";
import { AxisRange } from "./AxisRange";
import { PropertyMetadata } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var FinancialOverlay = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(FinancialOverlay, _super);
    function FinancialOverlay() {
        var _this = _super.call(this) || this;
        _this.tq = false;
        _this.tq = false;
        return _this;
    }
    FinancialOverlay.prototype.get_ds = function () {
        return true;
    };
    FinancialOverlay.prototype.k3 = function (a, b, c, d) {
        _super.prototype.k3.call(this, a, b, c, d);
        if (this.qg != null && typeCast(ISortingAxis_$type, this.qg) !== null) {
            this.qg.i$i();
        }
        this.qx.bx.e(this.fv);
        this.tr();
        if (this.q2 != null) {
            this.q2.c0();
        }
        this.ml(true);
    };
    FinancialOverlay.prototype.get_fa = function () {
        return true;
    };
    FinancialOverlay.prototype.l7 = function (a, b, c, d) {
        switch (b) {
            case "FastItemsSource":
                this.tq = false;
                break;
            case FinancialOverlay.$$p[0]:
                this.tq = false;
                this.ml(false);
                this.ls();
                break;
            case "XAxis":
                this.tq = false;
                break;
        }
        _super.prototype.l7.call(this, a, b, c, d);
    };
    FinancialOverlay.prototype.bp = function () {
        if (this.bq == 0) {
            return 1;
        }
        else {
            return _super.prototype.bp.call(this);
        }
    };
    FinancialOverlay.prototype.ex = function (a, b) {
        if (this.ew(a, b)) {
            return true;
        }
        return false;
    };
    FinancialOverlay.prototype.ac = function () {
        _super.prototype.ac.call(this);
        this.ml(false);
    };
    FinancialOverlay.prototype.eo = function (a) {
        var b = this.ck != null ? this.ck.indexOf(a) : -1;
        var c = this.b0.bv;
        c = c.copy();
        var d = this.b0.bu;
        var e = new Rect(0, 0, 0, 1, 1);
        var f = this.px(this.b0);
        var g = new ScalerParams(0, e, e, this.qg.cg, f);
        var h = new ScalerParams(0, e, e, this.q2.cg, f);
        h.b = this.ge();
        if (b >= 0 && Rect.l_op_Inequality(c, null) && Rect.l_op_Inequality(d, null)) {
            if (this.qg != null) {
                var i = this.qg.ei(b, g);
                if (i < c.left + 0.1 * c.width) {
                    i = i + 0.4 * c.width;
                }
                if (i > c.right - 0.1 * c.width) {
                    i = i - 0.4 * c.width;
                }
                c.x = i - 0.5 * c.width;
            }
            if (this.q2 != null && this.rb != null && this.ra != null && b < this.rb.count && b < this.ra.count) {
                var j = this.q2.ei(this.rb.item(b), h);
                var k = this.q2.ei(this.ra.item(b), h);
                if (!isNaN_(j) && !isNaN_(k)) {
                    var l = Math.abs(j - k);
                    if (c.height < l) {
                        c.height = l;
                        c.y = Math.min(j, k);
                    }
                    else {
                        if (j < c.top + 0.1 * c.height) {
                            j = j + 0.4 * c.height;
                        }
                        if (j > c.bottom - 0.1 * c.height) {
                            j = j - 0.4 * c.height;
                        }
                        c.y = j - 0.5 * c.height;
                    }
                }
            }
            this.b8.au(this.cd, c, true);
        }
        return b >= 0;
    };
    FinancialOverlay.prototype.ap = function (a) {
        if (a != null && a == this.q2 && this.rb != null && this.ra != null) {
            return new AxisRange(this.rb.minimum, this.ra.maximum);
        }
        return null;
    };
    FinancialOverlay.$t = markType(FinancialOverlay, 'FinancialOverlay', FinancialSeries.$);
    FinancialOverlay.$$p = markDep(DependencyProperty, PropertyMetadata, FinancialOverlay, 'raisePropertyChanged', ['IgnoreFirst:ts:tu', [1, 0]]);
    return FinancialOverlay;
}(FinancialSeries));
export { FinancialOverlay };
